import React from "react"
import { useTranslation } from "react-i18next"

import { Content, Description } from "pages/static/elements"
import Title from "components/ui/Title"

const InternalError = () => {
  const { t } = useTranslation()

  return (
    <Content data-testid="internal-error-page">
      <Title>{t("pages.internal_error.title")}</Title>
      <Description>{t("pages.internal_error.description")}</Description>
    </Content>
  )
}

export default InternalError
